import { screenResizerChecker } from '@src/utils/screen-resizer-checker';
// This JS is only used on app/sections/jobs/variations/_display_six_jobs.html.haml

const resetClasses = (visibleJobsList) => {
  Array.from(visibleJobsList).map((visibleJob) => {
    const horizontalLineEl = visibleJob.getElementsByClassName('horizontal-line')[0];
    const verticalLineEl = visibleJob.getElementsByClassName('vertical-line')[0];

    if (horizontalLineEl) {
      horizontalLineEl.classList.remove('hidden');
    };
    if (verticalLineEl) {
      verticalLineEl.classList.remove('hidden');
    };
  })
};

const isOnLastRow = (jobCounter, visibleJobsCounter, numberOfCardsPerRow) => {
  const numberOfCardsOnLastRow = visibleJobsCounter % numberOfCardsPerRow;
  const jobCounterWithBorder = visibleJobsCounter - numberOfCardsOnLastRow;

  if (jobCounter > jobCounterWithBorder) {
    return true;
  }
}

const removeBorderBottom = (jobCounter, visibleJob, visibleJobsCounter) => {
  const horizontalLineEl = visibleJob.getElementsByClassName('horizontal-line')[0];

  // Large screen
  if (window.matchMedia(`(min-width: 1096px)`).matches) {
    if (isOnLastRow(jobCounter, visibleJobsCounter, 3)) {
      if (horizontalLineEl) {
        horizontalLineEl.classList.add('hidden');
      }
    };
  } else if (
    window.matchMedia(`(max-width: 1095px)`).matches &&
    !window.matchMedia(`(max-width: 728px)`).matches
  ) {
    // Medium screen
    if (isOnLastRow(jobCounter, visibleJobsCounter, 2)) {
      if (horizontalLineEl) {
        horizontalLineEl.classList.add('hidden');
      }
    };
  } else {
    // Small screen
    if (jobCounter === visibleJobsCounter) {
      if (horizontalLineEl) {
        horizontalLineEl.classList.add('hidden');
      }
    };
  };
};

const removeBorderRight = (jobCounter, visibleJob, visibleJobsCounter) => {
  const verticalLineEl = visibleJob.getElementsByClassName('vertical-line')[0];
  // Large screen
  if (window.matchMedia(`(min-width: 1096px)`).matches) {
    if (jobCounter % 3 == 0) {
      if (verticalLineEl) {
        verticalLineEl.classList.add('hidden');
      }
    }
  } else if (
    window.matchMedia(`(max-width: 1095px)`).matches &&
    !window.matchMedia(`(max-width: 728px)`).matches
  ) {
    // Medium screen
    if (jobCounter % 2 == 0) {
      if (verticalLineEl) {
        verticalLineEl.classList.add('hidden');
      }
    }
  } else {
    // Small screen
    verticalLineEl.classList.add('hidden');
  };
};

const styleCards = () => {
  const visibleJobs = document.querySelectorAll('.jobs-list__card-wrapper:not(.hidden)');
  const visibleJobsCounter = visibleJobs.length;

  if (visibleJobsCounter === 0) {
    return
  };

  resetClasses(visibleJobs);


  Array.from(visibleJobs).map((visibleJob, index) => {
    const jobCounter = index + 1;

    removeBorderBottom(jobCounter, visibleJob, visibleJobsCounter);
    removeBorderRight(jobCounter, visibleJob, visibleJobsCounter);
  })
}

export const styleCardsBorders = () => {
  screenResizerChecker(() => styleCards(), () => styleCards(), 1095);
};
